// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDiffOutlinedSvg from "@fishx/icons-svg/es/asn/PDiffOutlined";
import FishxIcon from '../components/FishxIcon';

var PDiffOutlined = function PDiffOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDiffOutlinedSvg
  }));
};

PDiffOutlined.displayName = 'PDiffOutlined';
export default React.forwardRef(PDiffOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDiffOutlined.js
// module id = 3334
// module chunks = 0